module.exports = __webpack_public_path__ + "static/img/PC-4.266e8f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/PC-4.png
// module id = OSXI
// module chunks = 0